import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the application is running inside an iframe
 * @returns {boolean} true if running in iframe, false otherwise
 */
const useIsInIframe = () => {
  // Initialize with the actual value immediately to prevent flash
  const [isInIframe, setIsInIframe] = useState(() => {
    try {
      return window.self !== window.top;
    } catch (e) {
      // If there's a cross-origin error, we're likely in an iframe
      // (accessing window.top from cross-origin throws an error)
      return true;
    }
  });

  useEffect(() => {
    // Double-check on mount to ensure accuracy (only runs once)
    try {
      const inIframe = window.self !== window.top;
      setIsInIframe(inIframe);
    } catch (e) {
      setIsInIframe(true);
    }
  }, []);

  return isInIframe;
};

export default useIsInIframe;
